import { Link } from "react-router-dom";
import ArticleCard from "@/components/feature/ArticleCard";
import { popularArticles } from "@/mocks/articles";

interface Props {
  title: string;
  subtitle: string;
  list: ReturnType<typeof popularArticles>;
  morePath?: string;
}

export default function LatestSection({ title, subtitle, list, morePath }: Props) {
  const popular = popularArticles(5);
  const tagPool = Array.from(new Set(list.flatMap((a) => a.tags))).slice(0, 10);

  return (
    <section aria-labelledby="latest-heading" className="border-t border-background-200 bg-background-100">
      <div className="container-page grid grid-cols-1 gap-10 py-14 lg:grid-cols-[1fr_320px]">
        <div>
          <div className="flex flex-wrap items-end justify-between gap-3">
            <div>
              <span className="text-xs font-medium tracking-[0.2em] text-primary-600">ARCHIVE</span>
              <h2 id="latest-heading" className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                {title}
              </h2>
              <p className="mt-2 text-sm text-foreground-600">{subtitle}</p>
            </div>
            {morePath && (
              <Link
                to={morePath}
                className="whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-primary-800"
              >
                查看全部
              </Link>
            )}
          </div>

          <div className="mt-4">
            {list.map((a) => (
              <ArticleCard key={a.slug} article={a} variant="row" />
            ))}
          </div>
        </div>

        <aside className="flex flex-col gap-6">
          <div className="rounded-lg border border-background-200 bg-background-50 p-5">
            <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
              <i className="ri-fire-line text-primary-600" aria-hidden="true" />
              热门排行
            </h3>
            <div className="mt-2">
              {popular.map((a, index) => (
                <ArticleCard key={a.slug} article={a} variant="mini" rank={index + 1} />
              ))}
            </div>
          </div>

          <div className="rounded-lg border border-background-200 bg-background-50 p-5">
            <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
              <i className="ri-price-tag-3-line text-accent-600" aria-hidden="true" />
              热门标签
            </h3>
            <ul className="mt-4 flex flex-wrap gap-2">
              {tagPool.map((tag) => (
                <li key={tag}>
                  <Link
                    to="/channels"
                    className="inline-block whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1.5 text-xs text-secondary-800 transition-colors hover:bg-secondary-200"
                  >
                    {tag}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-lg border border-primary-200 bg-primary-50 p-5">
            <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
              <i className="ri-mail-send-line text-primary-700" aria-hidden="true" />
              提供线索
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">
              如果你手上有可公开的信息线索，欢迎通过联系表单告诉我们，我们会认真核对后整理。
            </p>
            <Link
              to="/contact"
              className="mt-4 flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              提交线索
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </Link>
          </div>
        </aside>
      </div>
    </section>
  );
}